<template>
  <!-- 1.all-container-start -->
  <div class="all-container">
    <!-- 财务中心->开票信息管理 -->
    <div class="main2">
      <div class="title">开票信息管理</div>
      <div class="main2">
        <div class="search">
          <el-form :model="queryParams" ref="queryForm" :inline="true">
            <el-form-item label="申请开票时间" prop="beginTime">
              <el-date-picker
                clearable
                size="small"
                style="width: 200px"
                v-model="queryParams.beginTime"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="开始时间"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="—" prop="endTime" class="df-sjkjs">
              <el-date-picker
                clearable
                size="small"
                style="width: 200px"
                v-model="queryParams.endTime"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="截止时间"
              >
              </el-date-picker>
            </el-form-item>

            <el-form-item>
              <el-button
                icon="el-icon-search"
                size="small"
                style="border-color:#97c5e9;font-size:14px;border-radius:0;padding:7px 20px 8px;"
                @click="search"
                >搜索</el-button
              >
            </el-form-item>
          </el-form>
        </div>

        <el-table
          :data="aryList"
          style="width: 100%"
          :default-expand-all="true"
          :cell-style="{
            'text-align': 'center',
            'border-color': '#dbdbdb',
            'position': 'relative',
            'background-color': '#f3f1f2',
            'border-right': '1px solid #e7e6e4',
          }"
          :header-cell-style="{
            'background-color': '#b6b6b6',
            color: '#000',
            fontSize: '14px',
            fontWeight: '300',
            'text-align': 'center',
          }"
        >
          <el-table-column prop="num" align="center" label="序号" width="65">
            <template slot-scope="scope">
              {{ scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="时间" min-width="165">
            <template slot-scope="scope">
              {{ scope.row.createTime || "" }}
            </template>
          </el-table-column>
          <el-table-column width="1" type="expand">
            <template slot-scope="props">
              <div style="width: 100%">
                <el-form
                  label-position="left"
                  inline
                  class="demo-table-expand2"
                  style="margin:0 0 0 -70px;padding:10px 0;background:#f3f1f2;"
                >
                  <el-form-item label="发票抬头：" style="width:50%;">
                    {{ props.row.invoiceName || props.row.customerName }}
                  </el-form-item>
                  <el-form-item label="发票明细：" style="width:50%;">
                    {{ props.row.invoiceInfo || "" }}
                  </el-form-item>
                  <el-form-item label="注册办公地址：">
                    <span>{{ props.row.regAddress || "" }}</span>
                  </el-form-item>
                  <el-form-item label="注册固定电话：">
                    <span>{{ props.row.regTel }}</span>
                  </el-form-item>
                  <el-form-item label="开户银行名称：">
                    <span>{{ props.row.bankName }}</span>
                  </el-form-item>
                  <el-form-item label="基本开户账号：">
                    <span>{{ props.row.bankNum }}</span>
                  </el-form-item>

                  <el-form-item label="收票人：">
                    <span>{{ props.row.linkMan || "" }}</span>
                  </el-form-item>
                  <el-form-item label="收票电话：">
                    <span>{{ props.row.cellPhone }}</span>
                  </el-form-item>
                  <el-form-item label="收票地址：" style="width:50%;">
                    <span>{{ props.row.linkAddress }}</span>
                  </el-form-item>
                  <el-form-item label="处理时间：">
                    <span>{{ props.row.tranTime }}</span>
                  </el-form-item>

                  <el-form-item label="处理结果：">
                    <span>{{ props.row.tranResult }}</span>
                  </el-form-item>
                  <el-form-item label="快递公司：">
                    <span>{{ props.row.deliveryType }}</span>
                  </el-form-item>
                  <el-form-item label="快递单号：">
                    <span>{{ props.row.deliveryNum }}</span>
                  </el-form-item>
                  <el-form-item label="订单号：">
                    <span>{{ props.row.orderNum }}</span>
                  </el-form-item>
                  <el-form-item label="备注：" style="width:75%;">
                    {{ props.row.remark }}
                  </el-form-item>
                </el-form>
              </div>
            </template>
          </el-table-column>

          <el-table-column prop="invoiceNum" label="开票税号" min-width="140">
            <template slot-scope="scope">
              <el-link :underline="false" @click="watchOrder(scope.row)">{{
                scope.row.invoiceNum
              }}</el-link>
            </template>
          </el-table-column>
          <el-table-column prop="invoiceMoney" label="开票金额" min-width="95">
            <template slot-scope="scope">
              {{ to_f(scope.row.invoiceMoney || 0.0) }}
            </template>
          </el-table-column>
          <el-table-column
            prop="consigneePhone"
            label="开票类型"
            min-width="110"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.invoiceType == 1">普通发票</span>
              <span v-else-if="scope.row.invoiceType == 2">专用发票</span>
              <span v-else-if="scope.row.invoiceType == 3">电子发票</span>
              <span v-else>--</span>
            </template>
          </el-table-column>
          <el-table-column prop="customerName" label="客户名称" min-width="200">
            <template slot-scope="scope">
              {{ scope.row.customerName }}
            </template>
          </el-table-column>
          <el-table-column prop="status" label="状态" min-width="85">
            <template slot-scope="scope">
              <span v-if="scope.row.status == 0">未处理</span>
              <span v-else-if="scope.row.status == 1">已处理</span>
              <span v-else>--</span>
            </template>
          </el-table-column>
        </el-table>
        <br />
        <el-pagination
          v-if="totalPages > 0"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNum"
          :page-sizes="[10, 20, 30, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
        <el-button size="mini" style="display:inline-block;">GO</el-button>
      </div>
    </div>
    <!-- 财务中心->开票信息管理 -->
  </div>
  <!-- 1.all-container-end -->
</template>

<script>
import {
  getInvoiceListRequest,
  delInvoiceRequest,
} from "../../../public/js/service";

export default {
  data() {
    // 1.data
    return {
      totalPages: 1, //总页码,
      pageNum: 1, //当前页码
      total: 1, //总条数
      pageSize: 10, //每页条数
      aryList: [], // 数据列表
      token: "", //token
      queryParams: {
        orderNum: null,
        beginTime: null,
        endTime: null,
      },
    };
  },

  components: {},

  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.pageNum = val;
      this.getList();
    },

    getList() {
      // 3.4.获取开票信息
      let data = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        params: {
          beginTime: this.queryParams.beginTime,
          endTime: this.queryParams.endTime,
        },
      };

      getInvoiceListRequest(data).then((res) => {
        if (res) {
          this.total = res.totals || 1;
          this.totalPages = this.getTotalPages(this.total, this.pageSize);
          this.aryList = res.data;
        }
      });
    },

    deteleBefore(item) {
      // 3.5.删除开票信息之前
      let _this = this;
      this.$msgbox({
        title: "提示",
        message: "是否确认删除开票信息?",
        showCancelButton: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        callback(res) {
          if (res == "confirm") {
            _this.detele(item);
          }
        },
      });
    },

    detele(item) {
      // 3.6.删除开票信息
      delInvoiceRequest(item.invoiceId).then((res) => {
        if (res) {
          this.$message({
            type: "success",
            message: res.msg,
          });
          setTimeout(() => {
            this.getList();
          }, 300);
        }
      });
    },
    search() {
      this.pageNum = 1;
      this.getList();
    },
  },

  mounted() {
    // 4.mounted
    if (localStorage.token) {
      this.token = localStorage.token;
      this.getList(); // 4.1.获取开票信息管理数据
    }
  },
};
</script>
